export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11458.d122c632.jpg";